<template>
    <div>
        <h1 class="pagetitle px-8 md:px-12 clear-both lg:clear-none">
            {{ sorted_sections.length }} Report Chapter{{ sorted_sections.length == 1 ? '' : 's' }}
        </h1>

        <div class="flex w-full items-center bg-white rounded-md shadow px-4 py-3 mb-4">
            <i aria-hidden="true" class="material-icons text-3xl block" style="margin-left: -2px;">search</i>

            <input v-model="search_term"
                type="text"
                class="flex-1 text-xl focus:outline-none border-none p-0 ml-2"
            />
        </div>

        <div class="flex flex-col xl:flex-row mb-6">
            <div class="flex-1">
                <report-section-filter
                    :sections="sections"
                    :authors="authors"
                    :psych_models="psych_models"
                    :tags="tags"
                    :clicked_author_id="clicked_author_id"
                    :clicked_psych_model_id="clicked_psych_model_id"
                    :clicked_tag_id="clicked_tag_id"
                    @filtered="filtered"
                />
            </div>

            <div class="flex items-center rounded-md bg-indigo-200 xl:bg-transparent py-3 xl:py-0 pr-4 xl:pr-0 mt-4 xl:mt-0">
                <div class="mr-6 xl:mr-0 pl-3 xl:pl-6">
                    <div class="text-gray-800 uppercase text-xxs leading-none tracking-wide">
                        Sort
                    </div>

                    <i aria-hidden="true" class="material-icons text-3xl block -mb-1" style="margin-left: -2px;">sort</i>
                </div>

                <div class="flex">
                    <report-section-sort
                        label="A-Z"
                        value="name"
                        :selected="sort"
                        @click="sortBy"
                    />

                    <report-section-sort
                        label="Author"
                        value="author"
                        :selected="sort"
                        @click="sortBy"
                    />

                    <report-section-sort
                        label="Psych Model"
                        value="psych_model"
                        :selected="sort"
                        @click="sortBy"
                    />

                    <report-section-sort
                        label="Newest"
                        value="date_created"
                        :selected="sort"
                        @click="sortBy"
                    />
                </div>
            </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 xxl:grid-cols-4 gap-4">
            <report-section-card
                v-for="section in sorted_sections"
                :key="section.id"
                :section="section"
                :user_id="about.id"
                :annotation_count="annotation_counts[section.id]"
                @filterAuthor="filterAuthor"
                @filterPsychModel="filterPsychModel"
                @filterTag="filterTag"
            />
        </div>
    </div>
</template>

<script>
import ReportSectionCard from './report-section-card.vue';
import ReportSectionFilter from './report-section-filter.vue';
import ReportSectionSort from './report-section-sort.vue';

export default {
    components: {
        ReportSectionCard,
        ReportSectionFilter,
        ReportSectionSort,
    },

    props: {
        about: {},
        sections: {},
        authors: {},
        psych_models: {},
        tags: {},
        annotation_counts: {},
    },

    data() {
        return {
            sort: 'name',
            sections_with_search_text: this.addSearchText(),
            filtered_sections: this.sections_with_search_text,
            clicked_author_id: null,
            clicked_psych_model_id: null,
            clicked_tag_id: null,
            search_term: null,
        }
    },

    computed: {
        searched_sections() {
            return this.search_term
                ? this.filtered_sections.filter(section => section.search_text.includes(this.search_term.toLowerCase()))
                : [];
        },
        sorted_sections() {
            let sections = this.search_term
                ? this.searched_sections
                : this.filtered_sections;

            switch (this.sort) {
                case 'name':
                    return _.orderBy(sections, 'name', 'asc')
                    break;
                case 'author':
                    return _.orderBy(sections, 'authors.0.last_name', 'asc')
                    break;
                case 'psych_model':
                    return _.orderBy(sections, 'psych_models.0.name', 'asc')
                    break;
                case 'date_created':
                    return _.orderBy(sections, 'created_at', 'desc')
                    break;
                default:
                    return _.orderBy(sections, 'name', 'asc')
            }
        },
    },

    methods: {
        addSearchText() {
            return this.sections.map(section => {
                    section.search_text = [
                        section.short_desc,
                        section.name,
                        section.authors.map(author => author.first_name + ' ' + author.last_name).join(' '),
                        section.psych_models.map(model => model.name).join(' '),
                        section.tags.map(tag => tag.name).join(' '),
                    ].join(' ').toLowerCase();

                    return section;
            });
        },
        sortBy(order) {
            this.sort = order;
        },
        filtered(sections) {
            this.filtered_sections = sections;
        },
        filterAuthor(id) {
            this.clicked_author_id = id;
        },
        filterPsychModel(id) {
            this.clicked_psych_model_id = id;
        },
        filterTag(id) {
            this.clicked_tag_id = id;
        },
    },
}
</script>
